<template>
  <v-container>
    <v-form
      ref="form"
      v-model:model-value="valid"
      validate-on="input"
      @keydown.enter.prevent="sendData"
      @submit.prevent=""
    >
      <slot></slot>
      <v-btn
        @click="sendData"
        :disabled="!valid"
        :loading="loading"
        rounded="xl"
        size="large"
        elevation="10"
        variant="tonal"
        >{{ sendButtonMessage }}</v-btn
      >
      <v-btn
        @click="hide"
        rounded="xl"
        size="large"
        elevation="10"
        variant="tonal"
      >
        Abbrechen
      </v-btn>
      <v-btn
        @click="deleteData"
        v-if="mode === 'put'"
        style="float: right"
        color="error"
      >
        löschen
      </v-btn>
    </v-form>
  </v-container>
</template>

<script lang="ts">
export default {
  data() {
    return {
      valid: null,
      loading: false as boolean,
    };
  },
  props: {
    mode: {
      type: String,
      validator: (val: string) => {
        return val === "post" || val == "put";
      },
      required: true,
    },
  },
  emits: {
    "hide-form": () => {
      return true;
    },
    "delete-data": () => {
      return true;
    },
    "send-data": () => {
      return true;
    },
    "update:mode": (newMode: string) => {
      return typeof newMode === "string";
    },
  },
  computed: {
    sendButtonMessage() {
      if (this.mode === "put") {
        return "Speichern";
      } else {
        return "Hinzufügen";
      }
    },
  },
  methods: {
    hide() {
      this.$emit("hide-form");
    },
    deleteData() {
      this.$emit("delete-data");
    },
    sendData() {
      // this.loading = true;
      this.$emit("send-data");
    },
  },
  watch: {
    mode() {
      // @ts-ignore
      this.$refs.form.resetValidation();
      this.$emit("update:mode", this.mode);
    },
  },
};
</script>
